import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import RV from "simple-react-validator";
import InputMask from "react-input-mask";
import * as CONFIG from "./_config";
import ls from "local-storage";
toast.configure();
const axios = require("axios");

const Loader = () => <div className="loading-emp"></div>;

class Employmentteals extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.myRef = React.createRef();

    this.validator.visibleFields = [];
    this.state = {
      date: new Date(),
      formControls: {},
      stores: [],
      loading: false,
      storesGroups: null,
    };
  }
  onChange = (date) => this.setState({ date });

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // this.Stores();
      // this.Login();
    }
  }

  componentDidMount() {
    // console.log('employemnt',CONFIG.DATA.EMPLOYMENT_EMAIL)
    const script = document.createElement("script");

    script.src = "https://embed.teamengine.io/v0.1/bundle.js";

    script.async = true;

    this.myRef.appendChild(script);

    ls.set("redirectTo", window.location.href);
  }

  showLoader = () => {
    this.setState({ loading: true });
  };

  hideLoader = () => {
    this.setState({ loading: false });
  };

  //   Employment = async (e) => {

  //     e.preventDefault();

  //     this.showLoader();

  //     const datails = this.state.formControls;
  //     var body = '<table  border="1px" style="border-collapse: collapse;width: 100%; text-align:left;border:1px solid #000" cellpadding="3" cellspacing="0"> &&& </table>';
  //     // var body = '<table style="border-collapse: collapse;width: 100%; text-align:left"> &&& </table>';
  //     var tr = '';

  //     if (!this.validator.allValid()) {

  //       this.validator.showMessages();

  //       // console.log('this.validator',this.validator);
  //       this.forceUpdate();
  //       this.hideLoader();

  //       return false;

  //     }

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Name</td><td style='color:#333;border-bottom:0px;' width="33%">Phone</td><td style='color:#333;border-bottom:0px;' width="33%">Email</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['name']}</td><td style='border-top:0px'>${datails['phone']}</td><td style='border-top:0px'>${datails['email']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' colspan='3'>Street Address</td></tr>`;
  //     tr += `<tr><td style='border-top:0px' colspan='3'>${datails['street_address']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">City</td><td style='color:#333;border-bottom:0px;' width="33%">State / Province / Region</td><td style='color:#333;border-bottom:0px;' width="33%">Code / Country</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['city']}</td><td style='border-top:0px'>${datails['state']}</td><td style='border-top:0px'>${datails['zip_code']} / ${datails['country']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">How long have you lived at this address?*</td><td style='color:#333;border-bottom:0px;' width="33%">Referred By</td>`;
  //     if (CONFIG.DATA.BACKEND_HOST == "diamondfood" || CONFIG.DATA.BACKEND_HOST == "cashsaverstore" || CONFIG.DATA.BACKEND_HOST == "metrodiscount") {

  //       tr += `<td style='color:#333;border-bottom:0px;' width="33%">Position Applying For / Date you can start</td></tr>`;
  //     }
  //     else {
  //       tr += `<td style='color:#333;border-bottom:0px;' width="33%">Wage expected / Date you can start</td></tr>`;

  //     }
  //     tr += `<tr><td style='border-top:0px'>${datails['how_long_have_you_lived_at_this_address']}</td><td style='border-top:0px'>${datails['referred_by']}</td>

  //     <td style='border-top:0px'>${datails['wage_expected']} / ${datails['date_you_can_start']}</td></tr>`;

  //     tr += `<tr><td style='border-left:0px;border-right:0px' colspan="3"><div style="height:50px;"></div></td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' colspan='3' width="100%">Do you now or have you ever had a relative (includes in-laws) that worked for ${CONFIG.DATA.RSA_CLIENT_APP_NAME} ? (Yes or No)<br/> If yes, please list their name(s) and location(s)</td></tr>`;
  //     tr += `<tr><td style='border-top:0px' colspan='3'>${datails['do_you_now_or_have_you_ever_had_a_relative_includes_in_laws_that_worked_for_us']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Are you currently in High School (Yes or No)*</td><td style='color:#333;border-bottom:0px;' width="33%">College or University Credits (Yes or No) *    </td><td style='color:#333;border-bottom:0px;' width="33%">Did you earn a degree(s)? (Yes or No) *    </td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['are_you_currently_in_high_school']}</td><td style='border-top:0px'>${datails['college_or_university_credits']}</td><td style='border-top:0px'>${datails['did_you_earn_a_degree']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Company Name *    </td><td style='color:#333;border-bottom:0px;' width="33%">Phone Number *    </td><td style='color:#333;border-bottom:0px;' width="33%">Street Address * </td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['company_name1']}</td><td style='border-top:0px'>${datails['phone_number1']}</td><td style='border-top:0px'>${datails['street_address1']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">City</td><td style='color:#333;border-bottom:0px;' width="33%">State / Province / Region</td><td style='color:#333;border-bottom:0px;' width="33%">Code / Country</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['city2']}</td><td style='border-top:0px'>${datails['state2']}</td><td style='border-top:0px'>${datails['postal']} / ${datails['country2']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Start Date*    </td><td style='color:#333;border-bottom:0px;' width="33%">End Date*    </td><td style='color:#333;border-bottom:0px;' width="33%">Salary </td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['start_date']}</td><td style='border-top:0px'>${datails['end_date']}</td><td style='border-top:0px'>${datails['salary']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Reason for Leaving</td><td style='color:#333;border-bottom:0px;' colspan='2' width="66%">Please indicate the job duties you have performed which relate to the position for which you are applying* </td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['reason_for_leaving']}</td><td style='border-top:0px' valign="top" rowspan="3" colspan='2'>${datails['the_job_duties']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;'>How many jobs have you had in the last 5 years not listed above </td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['how_many_jobs_have_you_had_in_the_last_5_years_not_listed_above']}</td></tr>`;

  //     tr += `<tr><td style='border-left:0px;border-right:0px' colspan="3"><div style="height:50px;"></div></td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Are you eligible for employment in the United States? (Yes or No) *</td><td style='color:#333;border-bottom:0px;' colspan='2' width="66%">Additional Notes</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['are_you_eligible_for_employment_in_the_united_states']}</td><td style='border-top:0px' valign="top" rowspan="5" colspan='2'>${datails['additional_notes']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Days Available for Work*(Mon,Tue,Wed,Thu,Fri,Sat,Sun)</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['days_available_for_work']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Hours Available for Work</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['hours_available_for_work']}</td></tr>`;

  //     tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Name</td><td style='color:#333;border-bottom:0px;' width="33%">Store Location</td><td style='color:#333;border-bottom:0px;' width="33%">Date</td></tr>`;
  //     tr += `<tr><td style='border-top:0px'>${datails['name1']}</td><td style='border-top:0px'>${datails['store_location']}</td><td style='border-top:0px'>${datails['date2']}</td></tr>`;

  //     // var count = 0;
  //     // for (let [key, value] of Object.entries(datails)) {

  //     //   // console.log(count++, key, document.getElementsByName(key)[0].parentNode.textContent);

  //     //   if(key !=='Captcha') {
  //     //     tr+= '<tr><td>'+key.replace(/_/g," ")+' : </td><td>'+value+'</td></tr>'
  //     //     /*
  //     //     // DO NOT USE THIS FOR NOW, DUE TO BODY LIMITATION NOT ALL TEXT ARE SENT TO SERVER.
  //     //     tr+= '<tr><td style="padding: 3px; width:50%;  text-align: left;  border-bottom: 1px solid #eee;">'
  //     //       + document.getElementsByName(key)[0].parentNode.textContent.replace('*',"").trim()
  //     //       + '</td><td style="padding: 3px; width:50%; text-align: left;  border-bottom: 1px solid #eee;">'
  //     //       + value
  //     //       + '</td></tr>'
  //     //     */
  //     //   }
  //     // }

  //     body = body.replace('&&&', tr)

  //     // console.log(body);    return;

  //     const data = new FormData();
  //     data.append("method", "POST");
  //     data.append("apiurl", `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/SendEmail`);
  //     if (this.props && this.props.location.search === '?debug=1') {

  //       data.append('EmailId', "hriziya@gmail.com");
  //     }
  //     else {
  //       data.append('EmailId', CONFIG.DATA.EMPLOYMENT_EMAIL);//CONFIG.DATA.EMPLOYMENT_EMAIL
  //     }

  //     if (CONFIG.DATA.BACKEND_HOST == "diamondfood" || CONFIG.DATA.BACKEND_HOST == "cashsaverstore" || CONFIG.DATA.BACKEND_HOST == "metrodiscount") {
  //       data.append('EmailSubject', 'Enquiry for Employment diamond');
  //     } else {
  //       data.append('EmailSubject', 'Enquiry for Employment');
  //     }

  //     data.append('EmailBody', body);

  //     axios.post(CONFIG.API_ROOT, data)
  //       .then(res => {
  //         if (res.data.ErrorMessage.ErrorCode === 1) {

  //           window.scrollTo(0, 0);
  //           // window.grecaptcha.reset();
  //           this.hideLoader();

  //           toast.success('An email has been sent!');
  //           document.getElementById("empForm").reset();
  //         }
  //       })
  //       .catch(function (response) {
  //         console.log(response);
  //       });
  //   }

  Stores() {
    var ClientStores = ls.get("ClientStores");
    // console.log("storage", ClientStores);

    /*
      HR:2021-05-20
      Buche foods asked to add static locations only on the "Location" page 
      which shouldn to appear on website or any other place. 
      so we made separate API for fetching stores 
    */

    let IsBucheFoods = CONFIG.DATA.BACKEND_HOST == "buchefoods";

    if (false && !IsBucheFoods && ClientStores) {
      this.setState({ stores: ClientStores });
    } else {
      const data = new FormData();
      data.append("method", "POST");
      let apiurl = "";
      let reqheaders = {};

      if (IsBucheFoods) {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetStaticClientStores`;

        data.append("ClientDbName", CONFIG.DATA.RSA_CLIENT_DB_NAME);
        data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
        data.append("ClientStoreId", 0);
        data.append("Token", "");
        reqheaders = { domainname: "clientsupport" };
      } else if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
        reqheaders = { domainname: CONFIG.DATA.RSA_SUBDOMAIN };
      } else {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
        reqheaders = { domainname: CONFIG.DATA.RSA_SUBDOMAIN };
      }

      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: reqheaders,
        })
        .then((res) => {
          // console.log('res',res);
          ls.set("ClientStores", res.data.GetClientStores);

          var hasSectionName = false;
          if (
            res.data.GetClientStores &&
            res.data.GetClientStores != null &&
            res.data.GetClientStores.length > 0
          ) {
            hasSectionName =
              res.data.GetClientStores[0].SectionName != null &&
              res.data.GetClientStores[0].SectionName.length > 0;
          }
          if (hasSectionName) {
            // console.log("hasSectionName")
            const groupByKey = (list, key) =>
              list.reduce(
                (hash, obj) => ({
                  ...hash,
                  [obj[key]]: (hash[obj[key]] || []).concat(obj),
                }),
                {}
              );
            let storesGroupsList = groupByKey(
              res.data.GetClientStores,
              "SectionName"
            );
            // console.log('storesGroupsList', storesGroupsList);
            this.setState({
              stores: res.data.GetClientStores,
              storesGroups: storesGroupsList,
            });
          } else {
            this.setState({ stores: res.data.GetClientStores });
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  render() {
    // var index = this.state.stores;
    //const uniqueStores =  index.filter( (ele, ind) => ind === index.findIndex( elem => elem.City === ele.City ));

    return (
      <div>
        {this.state.loading ? <Loader /> : null}

        <div className="main-container default-page pt-2 mt-2">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Employment</h2>
                      <ol className="breadcrumb ml-5">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/employment">Employment</a>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1 className="entry-title">Employment</h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span> Employment</span>
                </div>
              </div>
            </div>
          )}
          <div className="clearfix"></div>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-lg-12">
                <div
                  ref={(DOMNodeRef) => {
                    this.myRef = DOMNodeRef;
                  }}
                ></div>

                <div
                  id="team-engine-careers-widget"
                  data-orgKey="teals_market_"
                  ref={(DOMNodeRef) => {
                    this.myRef = DOMNodeRef;
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Employmentteals;
